import { motion } from "framer-motion";
import { GALLERY } from "@/data/content";
import { SectionHead } from "@/components/Reveal";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-ink py-24 sm:py-32 px-5 sm:px-10 lg:px-16 border-t border-zinc-800/70">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
        <SectionHead overline="The training experience">
          Sweat, coached.
          <span className="block text-stroke">Not suffered.</span>
        </SectionHead>
        <p className="text-zinc-500 text-xs uppercase tracking-[0.2em] max-w-[220px] leading-relaxed">
          Small groups · coached movement · group energy
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 auto-rows-[240px] sm:auto-rows-[280px] gap-3 sm:gap-4">
        {GALLERY.map((g, i) => (
          <motion.figure
            key={g.src}
            data-testid={`gallery-item-${i}`}
            initial={{ opacity: 0, clipPath: "inset(12% 12% 12% 12%)" }}
            whileInView={{ opacity: 1, clipPath: "inset(0% 0% 0% 0%)" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden border border-zinc-800 ${g.span}`}
          >
            <img
              src={g.src}
              alt={g.alt}
              loading="lazy"
              className="h-full w-full object-cover grayscale-[25%] transition-all duration-700 group-hover:grayscale-0 group-hover:scale-[1.06]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <figcaption className="absolute bottom-4 left-4 right-4 text-[10px] uppercase tracking-[0.2em] text-zinc-200 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
              {g.alt}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
